<template>
  <v-form v-model="Profile.isValid" ref="form">
    <v-card tile flat>
      <v-card-title class="headline font-weight-bold">
        {{ $t(`profilePage.changePass`) }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols :sm="4">
            <v-text-field
              required
              :rules="[Rules.minPass]"
              :append-icon="`mdi-eye${vis1 ? '-off' : ''}`"
              :type="vis1 ? 'password' : ''"
              @click:append="() => (vis1 = !vis1)"
              v-model="Profile.obj.oldPassword"
            >
              <template #label>
                {{ $t(`profilePage.oldPass`) }}
                <span class="red--text">
                  <strong>*</strong>
                </span>
              </template>
            </v-text-field>
            <v-text-field
              required
              :rules="[Rules.minPass]"
              :append-icon="`mdi-eye${vis2 ? '-off' : ''}`"
              :type="vis2 ? 'password' : ''"
              @click:append="() => (vis2 = !vis2)"
              v-model="Profile.obj.newPassword"
            >
              <template #label>
                {{ $t(`profilePage.newPass`) }}
                <span class="red--text">
                  <strong>*</strong>
                </span>
              </template>
            </v-text-field>
            <v-text-field
              required
              :rules="[confirmNewPass]"
              :append-icon="`mdi-eye${vis3 ? '-off' : ''}`"
              :type="vis3 ? 'password' : ''"
              @click:append="() => (vis3 = !vis3)"
              v-model="Profile.obj.confirmNewPass"
            >
              <template #label>
                {{ $t(`profilePage.confirmPassword`) }}
                <span class="red--text">
                  <strong>*</strong>
                </span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-4">
        <v-btn
          tile
          color="primary"
          :disabled="
            !Profile.isValid ||
            Profile.obj.newPassword != Profile.obj.confirmNewPass
          "
          @click="_fnChangePass()"
        >
          {{ $t(`profilePage.change`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
export default {
  data() {
    return {
      model: "Profile",
      vis1: true,
      vis2: true,
      vis3: true,
      confirmNewPass: (v) =>
        v === this[this.model].obj.newPassword || this.$t(`rule.confirmFail`),
    };
  },
  methods: {
    async _fnChangePass() {
      await this.fnPost({
        url: "/v1/admin/change-password",
        model: this.model,
      });
      this.$refs.form.reset();
    },
  },
};
</script>
